import setDependencies from './prod_dependencies'

export default setDependencies
